import React from 'react';
import { ExpandableSidebar, Pages, Wrapper } from 'retro';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import QueuesIcon from '@atlaskit/icon/glyph/queues';
import PeopleGroupIcon from '@atlaskit/icon/glyph/people-group';
import AllBins from './AllBins';
import CreateBin from './CreateNewBin';
import ClientMapping from './ClientMapping';

export default function Render() {
  const HISTORY = useHistory();
  const location = useLocation();

  const items = [
    {
      title: 'Bin Management',
      actions: [
        {
          title: 'All BINs',
          icon: <QueuesIcon size='small' />,
          active: location.pathname === '/app/demo/bin-management',
          onClick: () => HISTORY.push('/app/demo/bin-management'),
        },
        {
          title: 'Create New BIN',
          icon: <PeopleGroupIcon size='small' />,
          active: location.pathname.includes('/app/demo/bin-management/new'),
          onClick: () => HISTORY.push('/app/demo/bin-management/new'),
        },
        {
          title: 'Client Mapping',
          icon: <PeopleGroupIcon size='small' />,
          active: location.pathname.includes('/app/demo/bin-management/mapping'),
          onClick: () => HISTORY.push('/app/demo/bin-management/mapping'),
        },
      ],
    },
  ];

  return (
    <div style={{ display: 'flex', height: '100vh', width: '100%' }}>
      <ExpandableSidebar items={items} />
      <Wrapper style={{ flex: 1 }}>
        <Switch>
          <Route path='/app/demo/bin-management' exact component={AllBins} />
          <Route path='/app/demo/bin-management/new' component={CreateBin} exact/>
          <Route path='/app/demo/bin-management/new/:id' component={CreateBin} exact/>
          <Route path='/app/demo/bin-management/mapping' component={ClientMapping} exact />
        </Switch>
      </Wrapper>
    </div>
  );
}
